/** Textos de plano / faturas na Minha conta. */
export const MINHA_CONTA_BILLING = {
  planSectionTitle: 'Plano',
  invoicesSectionTitle: 'Faturas',
  renewalLabel: 'Renovação em',
  renewalUnknown: 'Data de renovação será atualizada após o próximo pagamento.',
  statusActive: 'Ativo',
  statusPixManual: 'PIX manual',
  statusPastDue: 'Pagamento em atraso — atualize na área de planos',
  statusPaymentFailed: 'Pagamento recusado — atualize na área de planos',
  statusPending: 'Pendente',
  statusCancelled: 'Cancelado',
  statusCancelScheduled:
    'Plano Cancelado. Não haverá cobrança após o fim do período.',
  /** Linha abaixo do status quando o cancelamento já está agendado (Stripe). */
  planAccessUntilPrefix: 'Acesso à plataforma até:',
  /** Modal de confirmação (substitui `cancelPlanConfirm` em fluxo com modal). */
  cancelPlanModalTitle: 'Cancelar assinatura?',
  cancelPlanModalIntro: 'Confira os dados do seu plano antes de confirmar:',
  cancelPlanModalPlanLabel: 'Plano',
  cancelPlanModalPriceLabel: 'Valor',
  cancelPlanModalAccessLabel: 'Uso da plataforma até',
  cancelPlanModalAccessFallback:
    'A data exata de término será alinhada ao fim do período já pago; pode ser atualizada após o próximo ciclo.',
  cancelPlanModalExplanation:
    'Ao confirmar, o cancelamento será agendado para o fim do período de cobrança atual. Não haverá nova cobrança após essa data.',
  cancelPlanModalBack: 'Voltar',
  cancelPlanModalConfirm: 'Confirmar Cancelamento',
  cancelPlanSuccess: 'Cancelamento agendado para o fim do período atual.',
  noPlanName: 'Plano',
  invoicesEmpty: 'Nenhuma fatura registrada ainda.',
  invoicesLoadError: 'Não foi possível carregar as faturas.',
  downloadUnavailable: 'Comprovante enviado por e-mail após a cobrança.',
} as const;
